blue.ready('anchor', '[data-anchor]', link => {
	const scroll = function(e) {
		e.preventDefault()
		let anchor = this.getAttribute('data-anchor')
		let dest = document.querySelector(`${anchor}`)

		window.scrollBy({
			behavior: 'smooth',
			top: dest.getBoundingClientRect().top
		})
	}

	link.addEventListener('click', scroll)
})